import React from 'react'
import loadingGif from '../../assets/images/loading-gif.webp'
import PropTypes from 'prop-types'
const { useDownloadPicture } = require('repositories/usecases/use.picture')

const AvatarIcon = ({ filename }) => {
  const [{ imageUrl, loading }] = useDownloadPicture('user_pictures', filename)

  let image = <img src={loadingGif} className="img-avatar" alt="Avatar" />
  if (!loading) {
    image = <img src={imageUrl} className="img-avatar" alt="Avatar" />
  }

  return image
}

AvatarIcon.propTypes = {
  filename: PropTypes.string,
}

export default AvatarIcon
